export enum MEDIA_QUERY {
  MOBILE = "(max-width: 576px)",
  TABLET = "(max-width: 768px)",
  DESKTOP = "(max-width: 992px)",
  DESKTOP_LARGE = "(max-width: 1200px)",
}
